import React from "react";
import { TransactionRuleCondition } from "@common/types/transactionRule";
import { useClasses } from "@api/class.api";
import { RuleTagRow } from "../RuleTagRow";

interface Props {
    condition: TransactionRuleCondition;
}

export const RuleClassCondition: React.FC<Props> = ({ condition }) => {
    const { classesMap } = useClasses();

    if (!Array.isArray(condition.value)) {
        return null;
    }

    const classLabels = (condition.value as string[])
        .map((id) => classesMap.get(id)?.label)
        .filter((label): label is string => !!label);

    if (!classLabels.length) {
        return null;
    }

    return <RuleTagRow label="Class" type="condition" values={classLabels} />;
};
